import React, { useContext, useState, useEffect } from 'react';
import { AccountContext } from '../Accounts';
import { useTranslation } from 'react-i18next';
import { useCustomTranslator } from '../utils/customTranslator';
import { DataTypeContext } from '../DataTypes';

const ForgotPasswordForm = (props) => {
    const { t } = useTranslation();
    const customT = useCustomTranslator();
    const { username, sendPasswordReset } = useContext(AccountContext);
    const [response, setResponse] = useState(null);
    const { dataTypes } = useContext(DataTypeContext);
    const { networkId } = dataTypes;

    useEffect(() => {
        const response = sendPasswordReset(username, networkId);
        response.then((res) => {
            if (!res.ok) {
                setResponse(res.status === 404 ? customT('api.error.NOT_FOUND') : customT('api.error.UNKNOWN'));
            } else {
                setResponse(t('user.passwordReset.thankYouMessage', { username: username }));
            }
        });
    }, [ username, setResponse, t, sendPasswordReset, networkId ]);

    return (
        <div>
            { response !== null &&
                <p className="text-center font-weight-bold">{response}</p>
            }
        </div>
    );
}

export default ForgotPasswordForm;
